import { AfterViewInit, Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { interval, take, takeWhile, tap } from 'rxjs';

import { LoaderService } from '../../services/loader/loader.service';
import { UserInfoService } from '../../services/user-info/user-info.service';
import { HabilitationDto } from '../../models/habilitation-dto.model';
import { HabilitationType } from '../../models/habilitation-type.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {

  @ViewChild('menuGestion') menuGestion: ElementRef;
  @ViewChild('menuDeleguerAUnTiers') menuDeleguerAUnTiers: ElementRef;
  @ViewChild('menuAjout') menuAjout: ElementRef;
  @ViewChild('gererHabilitationLink') gererHabilitationLink: ElementRef;

  autorisations: string[];
  roles: string[];
  canCreateDelegueTier: boolean;
  canCreateCLTier: boolean;
  canHandleCollaborateurs: boolean;
  hasToShowMenuAjouterCollaborateur = false;
  hasToShowMenuGererCollaborateur = false;
  hasToShowMenuDeleguerAUnTiers = false;
  storage: Storage = sessionStorage;
  habilitations: HabilitationDto[];

  constructor(
    private readonly router: Router,
    private readonly userInfo: UserInfoService,
    private readonly loaderService: LoaderService,
    private readonly injector: Injector
  ) {
    this.loaderService = this.injector.get<LoaderService>(LoaderService);
  }

  ngOnInit(): void {
     this.userInfo.getStoredHabilitationsUpdatedEvent().subscribe(habilitations => {
       this.habilitations = JSON.parse(
         sessionStorage.getItem(this.userInfo.habilitationAuthKey)
       );
       this.autorisations = this.userInfo.getAuthAutorisations();
       this.roles = this.userInfo.getAuthRoles();
       this.computeCanHandleCollaborateurs();
       if (!this.habilitations || this.habilitations.length === 0) {
         this.loaderService.show();
       }
       this.canCreateHabilitationPM();
       document.addEventListener('click', this.onClick.bind(this), true);
     });
  }

  ngAfterViewInit() {
    const events$ = interval(500).pipe(
      tap(() => this.gererHabilitationLink?.nativeElement?.focus()),
      take(30),
      takeWhile(() => this.gererHabilitationLink === undefined),
    );
    events$.subscribe();
  }

  onClick(event: MouseEvent) {
    if(!this.menuGestion?.nativeElement.contains(event.target)) {
      this.hasToShowMenuGererCollaborateur = false;
    }
    if(!this.menuAjout?.nativeElement.contains(event.target)) {
      this.hasToShowMenuAjouterCollaborateur = false;
    }
    if(!this.menuDeleguerAUnTiers?.nativeElement.contains(event.target)) {
      this.hasToShowMenuDeleguerAUnTiers = false;
    }
  }

  computeCanHandleCollaborateurs() {
    this.userInfo.canHandleCollaborateurs().subscribe(canHandle => this.canHandleCollaborateurs = canHandle);
  }

  goToHabilitation() {
    this.router.navigate(['/habilitation'], { queryParams: { start: true } });
  }

  getPermissions(permision: string): boolean {
    return this.userInfo.getPermissions(permision);
  }

  canCreateHabilitationPM(): void {
    this.canCreateDelegueTier = this.habilitations?.some((hab) => hab.structure.structureTiers === 'NON' &&
      (hab.roleMetier.code === HabilitationType.MANDATAIRE || hab.roleMetier.code === HabilitationType.REPRESENTANT_LEGAL));
    this.canCreateCLTier = this.habilitations?.some((hab) => hab.structure.structureTiers === 'NON' &&
      (hab.roleMetier.code === HabilitationType.MANDATAIRE || hab.roleMetier.code === HabilitationType.REPRESENTANT_LEGAL || hab.roleMetier.code === HabilitationType.DELEGUE));
  }

  toggleMenuAjouterCollaborateur() {
    this.hasToShowMenuAjouterCollaborateur = !this.hasToShowMenuAjouterCollaborateur;
    this.hasToShowMenuGererCollaborateur = false;
    this.hasToShowMenuDeleguerAUnTiers = false;
  }

  toggleMenuGererCollaborateur() {
    this.hasToShowMenuGererCollaborateur = !this.hasToShowMenuGererCollaborateur;
    this.hasToShowMenuAjouterCollaborateur = false;
    this.hasToShowMenuDeleguerAUnTiers = false;
  }

  toggleMenuDeleguerAUnTiers() {
    this.hasToShowMenuDeleguerAUnTiers = !this.hasToShowMenuDeleguerAUnTiers;
    this.hasToShowMenuAjouterCollaborateur = false;
    this.hasToShowMenuGererCollaborateur = false;
  }

}
